import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "../lib/api";
import { clearCache, getQueue } from "../lib/offline";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [store, setStore] = useState(null);

  const loadStore = useCallback(async () => {
    const { data } = await api.get("/settings");
    setStore(data);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        loadStore();
      })
      .catch(() => setUser(false));
  }, [loadStore]);

  const startSession = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    loadStore();
    return data.user;
  };
  const login = async (username, password) => startSession((await api.post("/auth/login", { username, password })).data);
  const register = async (body) => startSession((await api.post("/auth/register", body)).data);
  const can = (p) => !!user && user.permissions?.includes(p);

  const logout = async () => {
    if (getQueue().length && !window.confirm(`Ada ${getQueue().length} transaksi offline yang belum tersinkron. Tetap keluar? (data tetap tersimpan di perangkat ini)`)) return false;
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    clearCache();
    setUser(false);
    return true;
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, store, setStore, can, isOwner: !!user && user.role === "owner" }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
